import React from "react";

import { useModalContext } from "../../contexts/ModalContext/context";
import { useUserContext } from "../../contexts/UserContext";
import useAuth from "../../routes/login/AuthContext";
import { Switch } from "../Switch";
import { UserRoommateLockModal } from "../UserRoommateLockModal";

interface IProps {
  adminLocked: boolean;
  roommateId: string;
}

export const RoommateLockSwitch: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { setIsOpen } = useModalContext();
  const { user, loadUser } = useUserContext();

  const handleClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      {user && (
        <>
          <Switch switchProps={{ checked: props.adminLocked, onChange: handleClick }} isDisabled={isSuperAdminRead()} />
          <UserRoommateLockModal
            onSuccess={loadUser}
            l1Id={user.l1Id}
            l2Id={user.l2Id}
            l3Id={user.l3Id}
            adminLock={props.adminLocked}
            membershipIds={[props.roommateId, user?.membershipId]}
          />
        </>
      )}
    </>
  );
};
